import { ref, Ref } from "@vue/composition-api";
import Vue from "vue";

interface Toast {
    id: number;
    icon?: string;
    color: string;
    title?: string;
    message: string;
    timeout: number;
    display: boolean;
    dark: boolean;
}

interface ToastOptions {
    icon?: string;
    color?: string;
    title?: string;
    message: string;
    timeout?: number;
    dark?: boolean;
}

declare module "vue/types/vue" {
    interface Vue {
        $tosti: Tosti;
    }
}

class Tosti {
    public queue: Ref<Toast[]>;
    private lastId: number;

    constructor() {
        this.queue = ref<Toast[]>([]);
        this.lastId = 0;
    }

    public toast(options: ToastOptions) {
        const toast: Toast = {
            color: "primary",
            id: ++this.lastId,
            timeout: 4000,
            display: false,
            dark: true,
            ...options,
        };
        this.queue.value.unshift(toast);

        setTimeout(() => {
            toast.display = true;
        }, 50);

        setTimeout(() => {
            toast.display = false;
        }, toast.timeout - 250);

        setTimeout(() => {
            const index = this.queue.value.indexOf(toast);
            if (index === -1) return;
            this.queue.value.splice(index, 1);
        }, toast.timeout);
    }

    public primary(options: ToastOptions) {
        if (!options.color) options.color = "primary";
        options.icon = "mdi-bell-outline";
        this.toast(options);
    }

    public success(options: ToastOptions) {
        if (!options.color) options.color = "success";
        options.icon = "mdi-check-circle-outline";
        this.toast(options);
    }

    public info(options: ToastOptions) {
        if (!options.color) options.color = "info";
        options.icon = "mdi-information-outline";
        this.toast(options);
    }

    public warning(options: ToastOptions) {
        if (!options.color) options.color = "warning";
        // options.dark = false;
        options.icon = "mdi-alert-circle-outline";
        this.toast(options);
    }

    public error(options: ToastOptions) {
        if (!options.color) options.color = "error";
        options.icon = "mdi-close-circle-outline";
        this.toast(options);
    }
}

// // const plugin: PluginObject<Vue> = {
// //     install: (Vue: VueConstructor) => {
// //         Vue.prototype.$tosti = tosti;
// //     },
// // };
//
// // Vue.use(plugin);

const tosti = new Tosti();
export const useTosti = () => tosti;
Vue.prototype.$tosti = tosti;

declare module "vue/types/vue" {
    interface Vue {
        $tosti: Tosti;
    }
}
